module.exports = __webpack_public_path__ + "static/img/jiangxing.be6904f8.jpeg";